export class MedicalPrescriptionStatus {
  private static readonly options = new Map([
    [1, "Enviada"],
    [2, "Pendente"],
    [3, "Não Necessária"],
    [4, "Prazo de envio excedido"],
  ]);

  public static fromEnum(value: number): MedicalPrescriptionStatus {
    return new MedicalPrescriptionStatus(value);
  }

  private readonly description: string;

  private constructor(status: number) {
    this.description = MedicalPrescriptionStatus.options.get(status);
  }

  public getDescription(): string {
    return this.description;
  }
}

export enum MedicalPrescriptionStatusEnum {
  Valid = "Enviada",
  Pending = "Pendente",
  NotNeeded = "Não Necessária",
  Expired = "Prazo de envio excedido"
}